import { Alert } from 'antd'

export default function FormErrors (props) {
  if (!props.errors || !props.errors.length) {
    return null
  }
  const errors = props.errors.filter(error => (props.param ? error.param === props.param : error.param == null))
  if (!errors.length) {
    return null
  }
  return (
    <div style={{ marginTop: 4 }}>
      {errors.map((e, i) => <Alert key={i} type='error' message={e.message} banner style={{ marginBottom: 4 }} />)}
    </div>
  )
}
